<script lang="js" setup>
import { useLocalePath } from '#imports'
import { fix } from '~/utils/math'
import { useStore } from '~/store'
import { useUserStore } from '~/store/user'
import { useSpotStore } from '~/store/spot'

import LoginText from './LoginText.vue'
import IconAdd from '~/assets/images/spot/ic-add.svg'

const store = useStore()
const spot = useSpotStore()
const user = useUserStore()
const localePath = useLocalePath()
const list = computed(() => {
  return [
    { code: spot.base, avaliable: fix(spot.getBalanceByCode(spot.base).trade ?? '-', spot.as) },
    { code: spot.quote, avaliable: fix(spot.getBalanceByCode(spot.quote).trade ?? '-', 2) },
  ]
})
</script>

<template>
  <div class="bg-fillPagePrimary mt-0.5 flex-1 min-h-[400px]">
    <ClientOnly>
      <LoginText v-if="!user.isLogin" class="mx-auto mt-12" />
      <template v-else>
        <h2 class="flex items-center h-[38px] px-3 text-textPrimary text-sm font-medium border-b border-dividerPrimary">
          {{ $t('资产') }}
        </h2>
        <div class="p-3 space-y-4">
          <div v-for="i in list" :key="i.name" class="flex items-center justify-between text-xs text-textPrimary font-medium">
            <div class="flex gap-1 items-center">
              <common-x-image :src="store.getSpotIconByCode(i.code)" :alt="i.code" class="w-6 h-6 shrink-0" />
              <span>{{ $t('{0}余额', [i.code]) }}</span>
            </div>
            <div class="inline-flex items-center gap-1">
              <i18n-t keypath="可用 {0}" scope="global" tag="span" class="text-textSecondary">
                <em class="text-textPrimary">{{ i.avaliable }}</em>
              </i18n-t>
            </div>
          </div>
          <NuxtLink class="mt-4 flex" :to="localePath(`/assets/deposit/${spot.quote}`)">
            <common-x-button type="default" size="small" class="w-full">
              {{ $t('充值') }}
            </common-x-button>
          </NuxtLink>
        </div>
      </template>
    </ClientOnly>
  </div>
</template>
